import React from "react";
import { useGetWarehousePreferences } from "./useGetWarehousePreferences";
import useUpdateWarehousePreferences from "./useUpdateWarehousePreferences";

export function useWarehousePreferencesField(clinicId) {
  const { data, isLoading, refetch } = useGetWarehousePreferences(clinicId);
  const { updatePreferences, isUpdating } = useUpdateWarehousePreferences(clinicId);

  const [priceEntryMode, setPriceEntryMode] = React.useState("NETTO");
  const [defaultVat, setDefaultVat] = React.useState("");
  const [currency, setCurrency] = React.useState("EUR");
  const [initialized, setInitialized] = React.useState(false);
  const originalRef = React.useRef({ priceEntryMode: "NETTO", defaultVat: "", currency: "EUR" });

  React.useEffect(() => {
    if (!initialized && data) {
      const mode = data?.priceEntryMode ?? "NETTO";
      const vat = data?.defaultVat != null ? String(data.defaultVat) : "";
      const curr = data?.currency ?? "EUR";
      setPriceEntryMode(mode);
      setDefaultVat(vat);
      setCurrency(curr);
      originalRef.current = { priceEntryMode: mode, defaultVat: vat, currency: curr };
      setInitialized(true);
    }
  }, [data, initialized]);

  async function save() {
    if (
      priceEntryMode === originalRef.current.priceEntryMode &&
      defaultVat === originalRef.current.defaultVat &&
      currency === originalRef.current.currency
    ) {
      // Nothing changed -- skip the network call so a page-wide save
      // doesn't touch this setting when only something else was edited.
      return;
    }
    const result = await updatePreferences(
      priceEntryMode,
      defaultVat === "" ? null : Number(defaultVat),
      currency,
    );
    if (result) {
      originalRef.current = { priceEntryMode, defaultVat, currency };
      refetch();
    }
  }

  return {
    priceEntryMode,
    setPriceEntryMode,
    defaultVat,
    setDefaultVat,
    currency,
    setCurrency,
    save,
    isLoading,
    isUpdating,
  };
}
